export default __webpack_public_path__ + "static/media/login-gradient.bbfb8b87.png";